// extracted by mini-css-extract-plugin
module.exports = {"select":"PaginationSelectFilterField_select__2GZq2"};